// Helpers for the PWA service worker's page cache.
//
// The SW (public/sw.js) stores visited pages stale-while-revalidate under a
// cache whose name carries this prefix (PAGES_CACHE there). A plain reload
// would just repaint that cached document, so anything that needs the next
// navigation to hit the network — a deploy swap (ServiceWorkerRegistrar) or a
// sign-out (useAuth) — flushes these caches first. This module is the single
// source of truth for the prefix and the flush, and is intentionally
// dependency-free so it can be unit-tested without React/SW scaffolding.
//
// Keep PAGES_CACHE_PREFIX in sync with public/sw.js.
export const PAGES_CACHE_PREFIX = 'family-apps-pages-'

// The subset of cache names that belong to the SW page cache. Pure, so it can
// be tested directly; clearPagesCache() is the thin runtime wrapper.
export function pagesCacheKeys(allKeys: string[]): string[] {
  return allKeys.filter((key) => key.startsWith(PAGES_CACHE_PREFIX))
}

// Delete the SW's cached pages so the next navigation goes to the network.
// Best-effort: a no-op where the Cache API is unavailable (SSR, older
// browsers, or no SW), and callers should still proceed if it rejects.
export async function clearPagesCache(): Promise<void> {
  if (typeof caches === 'undefined') return
  const keys = await caches.keys()
  await Promise.all(pagesCacheKeys(keys).map((key) => caches.delete(key)))
}
